module.exports = __webpack_public_path__ + "static/media/sot-thumbnail.fa12f09b.png";